var AbstractWS = require("./AbstractWS");
var xmlToJson = require("../helpers/xmlToJson");

function EmployeesWS(viewModel) {
  var self;

  // Predicate this Web Service handler on the Abstract class of a Web
  // Service handler. This establishes core functionality required of
  // these such handlers, which can be overwritten by methods below.
  AbstractWS.apply(this, arguments);

  self = this;
  self.employeeName = ko.observable('');
  self.employeeId = null;
  self.name = 'EmployeesWS';			// Convenience name for debugging
  self.ticketClassifier = null;


	/**
	 * Defines the string to request API services
	 *
	 * @method serviceURL
	 * @returns {String}
	 */
  self.serviceURL = ko.computed(function () {
    return '/qless/api/v1/employee/employee';
  });


	/**
	 * This method iterates over the data returned from the service and
	 * converts the individual nodes into LocationModels and then assigns
	 * them to this object's locations collection.
	 *
	 * @method processData
	 * @param {XMLString} xmlData XML data returned from the service
	 * @returns {LocationsWS} Returns the object as chainable, for best practice
	 */
  self.processData = function (xmlData) {
    // Call the superclass method to perform any core actions
    AbstractWS.prototype.processData.call(self, xmlData);

    var json = xmlToJson.parse(xmlData);

    // If an error occured, we don't have a valid login, so
    // create a new Authenticator and log out the user
    if (json.error) {
      document.location.replace('/login/?logout=true');
    }
    // Otherwise, grab details from the employee node
    else {
      var empl = json.employee;
      var nameParts = [];

      if (empl.firstName) {
        nameParts.push(empl.firstName);
      }

      if (empl.lastName) {
        nameParts.push(empl.lastName);
      }

      if (empl.id) {
        self.employeeId = Number(empl.id);
      }

      self.employeeName(nameParts.join(' '));

      self.ticketClassifier = empl.ticketClassifier;
    }

    return self;
  };

  return self;
};

EmployeesWS.prototype = AbstractWS.prototype;
EmployeesWS.prototype.constructor = EmployeesWS;

module.exports = EmployeesWS
